import React from 'react';

import {REQUEST_STATUS_NAMES, REQUEST_STATUSES, RequestStatus} from 'requests/RequestConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pick from 'util/pick';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface RequestStatusFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function RequestStatusFilterForm(props: RequestStatusFilterFormProps): JSX.Element {
  const optionDatas: Array<OptionData> = REQUEST_STATUSES.map((status: RequestStatus) => ({
    name: REQUEST_STATUS_NAMES[status],
    value: status,
  }));

  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('Status', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={true}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
